import { useEffect, useState, useRef, RefObject } from 'react';
import { FaCaretRight } from 'react-icons/fa';
import Form from '../../Form';
import {
  Wrapper,
  Title,
  ProgressWrapper,
  Progress,
  ProgressArrow,
  Desc,
  FormWrapper,
  Button,
  ButtonWrapper,
} from "./style"

const Input = () => {
  return (
    <Wrapper>
      <Title>
        トークンが無効です。仮登録処理をもう一度行って下さい。
      </Title>
    </Wrapper>
  )
}
export default Input;
